// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-ad-spot[data-v-38986a1e] {\n  max-width: 100%; /* flex item: so it doesn't overflow */\n  min-width: 0; /* flex item: so it can shrink */\n}\n.c-ad-hero[data-v-38986a1e] {\n  position: absolute;\n  top: 0;\n  z-index: 1;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
